import React from "react";

const FoodAnalyzerHelp = () => (
  <div>
    <h2>Food Analyzer AI (Beta)</h2>
    <p>Concerned about the safety of your food? This tool allows you to analyze various food items for safety, nutritional content, and potential risks. Here’s how to use it: </p>
    <h3>Getting Started</h3>
    <ol>
      <li>Enter a food item in the input box.</li>
      <li>Click "Check Food Safety" to get detailed results.</li>
      <li>Review results, including safety ratings, risks, and recommendations.</li>
    </ol>
    <p><strong>Example:</strong> Type "Godiva Chocolate" or "spinach"</p>
    <h3>Features</h3>
    <ul>
    <li>Origin and Production</li>
        <li>Toxicological Assessment</li>
        <li>Half-Life and Retention Factors</li>
        <li>Consumer Safety Data</li>
        <li>Contamination Analysis</li>
        <li>Risk Stratification</li>
        <li>Consumption Guidelines</li>
        <li>Longevity Focused Analysis</li>
        <li>Safer Alternatives</li>
        <li>Recommendations</li>
    </ul>
    <p>Use this information to make informed decisions about your food choices.</p>
    {/* <div class="section" id="understanding-results"> */}
    <h3>Understanding Results</h3>
    <h4>Safety Assessment Categories</h4>
    <ul>
        <li><strong>Low Risk:</strong> Generally safe for consumption with standard precautions</li>
        <li><strong>Medium Risk:</strong> Requires attention to preparation methods and consumption amounts</li>
        <li><strong>High Risk:</strong> May require special handling or limited consumption</li>
    </ul>
    <h3>Longevity Analysis</h3>
    <p>Includes detailed information about:</p>
    <ul>
        <li>Nutritional Composition</li>
        <li>Probiotic Content</li>
        <li>Clean Ingredients</li>
        <li>Sustainability</li>
        <li>Specific Health Goals</li>
    </ul>
    <p><strong>Note:</strong> Pay special attention to the "Recommendations" section for practical guidance on alternative food consumption.</p>
    <h2>Printing Results</h2>
    <h3>How to Print</h3>
    <ol>
        <li>Review the complete results</li>
        <li>Click the "Print View" button at the bottom of the results</li>
        <li>Use your browser's print function or the system print dialog</li>
    </ol>
  </div>
  
);

export default FoodAnalyzerHelp;
